// import "@/registerServiceWorker";

import Vue from "vue";
import pinia from "@/pinia/pinia";
import * as VueGoogleMaps from "vue2-google-maps";

import App from "@/App.vue";
import HeadMetadata from "@/components/HeadMetadata.vue";
import vuetify from "@/plugins/vuetify";
import router from "@/router";
import { LogService } from "@/services";

Vue.component("HeadMetadata", HeadMetadata);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_KEY,
    libraries: "places",
  },
});

LogService.debug("Starting Vue app.");
new Vue({
  pinia,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
LogService.debug("Vue app started.");
